import { render, staticRenderFns } from "./QLDashboardDefault.vue?vue&type=template&id=229a370e&"
import script from "./QLDashboardDefault.vue?vue&type=script&lang=js&"
export * from "./QLDashboardDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports